export const areaOfCircle = (radius: number) => Math.PI * radius ** 2;
export const radiusOfCircle = (area: number) => (area / Math.PI) ** 0.5;
